import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=01fff18e&"
import script from "./Layer.vue?vue&type=script&lang=js&"
export * from "./Layer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fff18e')) {
      api.createRecord('01fff18e', component.options)
    } else {
      api.reload('01fff18e', component.options)
    }
    module.hot.accept("./Layer.vue?vue&type=template&id=01fff18e&", function () {
      api.rerender('01fff18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/Layer.vue"
export default component.exports